import * as wActs from './website-actions.js';
import * as wConst from '../consts/website-consts';

export function GetBlogPosts() {
  return (dispatch,getState) => {
    let page = "1";
    page = wActs.getParameterByName("page");
    if(wActs.isNullOrEmpty(page)) {page = "1"; }
    dispatch({type: wConst.ACTION_FETCH_BLOGPOSTS_PENDING, payload: false});
    let ref = wActs.GetReferer();
    if(wActs.isNullOrEmpty(ref)) {
      ref = getState().Website.ServerParams.Referer;
    }
    let headers = {
      'X-Alt-Referer': ref,
    };
    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/blog/posts?page=${page}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code !== 200) {
          dispatch({type: wConst.ACTION_FETCH_BLOGPOSTS_REJECTED, payload: data});
          dispatch(wActs.showWarning("WARN", data.Message));
        } else {
          dispatch({type: wConst.ACTION_FETCH_BLOGPOSTS_FULLFILLED, payload: data});
        }
      }).catch(function (ex) {
        dispatch({ type: wConst.ACTION_FETCH_BLOGPOSTS_REJECTED, payload: ex.toString() });

        dispatch(wActs.showWarning("WARN", ex.toString()));

    });
  }
}

export function SetBlogPathValue(path) {
  return (dispatch) => {
    dispatch({type: wConst.ACTION_SET_BLOGPATH, payload: path});
  }
}

export function showImage(w,h) {
  //console.log(h/w);
  if(h/w > .60) {
    return false;
  }
  return true;
}

export function GetBlogPost(slug) {
  return (dispatch,getState) => {
    dispatch({type: wConst.ACTION_FETCH_BLOGPOST_PENDING, payload: false});
    let ref = wActs.GetReferer();
    let headers = {
      'X-Alt-Referer': ref,
    };
    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/blog/post/${slug}`, { headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code !== 200) {
          dispatch({type: wConst.ACTION_FETCH_BLOGPOST_REJECTED, payload: data});
          dispatch(wActs.showWarning("WARN", data.Message));
        } else {
          dispatch({type: wConst.ACTION_FETCH_BLOGPOST_FULLFILLED, payload: data});
        }
      }).catch(function (ex) {
      dispatch({ type: wConst.ACTION_FETCH_BLOGPOST_REJECTED, payload: {Code: 500, Message: ex.toString()} });
      dispatch(wActs.showWarning("WARN", ex.toString()));

    });
  }
}

